// Angular
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

// Third party
// import { catchError, map, of, take } from 'rxjs';

// Local library
// import { ICommuicationCallResponse, TError } from '@amwager/util-ts';
import { GUEST, Environment as env } from "@amwager/util-ts";

// Local file
import { PermissionService, PusherService, SessionService } from '../services';
import { CommonFacade } from '../+state';
// import { ToteProgramAPIService } from '../apis';



interface IService {
  commonFacade: CommonFacade,
  sessionService: SessionService,
  pusherService: PusherService,
  permissionService: PermissionService,
  router: Router,
  url: string
}

export const accessGuardRouteFn: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const service: IService = {
    commonFacade: inject(CommonFacade),
    sessionService: inject(SessionService),
    router: inject(Router),
    url: state.url,
    pusherService: inject(PusherService),
    permissionService: inject(PermissionService)
  };

  return checkPageRoute(service);
}

const checkPageRoute = (service: IService): boolean => {
  if (!navigator.onLine) {
    if (service.url !== '/wager') {
      service.commonFacade.setIsConnectedInternet('checkPageRoute', false);
      return false;
    }
  }

  // check pages to redirect if cookie has token
  if (
    service.url === '/login'
    || service.url === '/signup'
    || service.url === '/forgot-password'
    || service.url === '/success-request-reset-password'
  ) {
    // console.log('1')
    // skip pages and redirect to wager if has token
    // TODO: guest user
    // if (service.sessionService.hasToken()) {
    if (service.sessionService.hasToken() && (service.sessionService.getUserEmail() !== GUEST)) {
      // console.log('2')
      redirectToHomeScreen(service);
      return false;
    }
  }

  if (service.url === '/complete-registration' || service.url === '/documents-verification') {
    if (service.sessionService.hasToken()) {
      if (service.permissionService.isGranted(
        service.sessionService.getRoleId(),
        service.url
      )) {
        service.commonFacade.setIsShowNavigation(false);
        return true;
      }
      else {
        service.router.navigateByUrl('/wager');
        return false;
      }
    }
  }

  // if to show navigation or not
  if (
    service.url === '/login'
    || service.url === '/signup'
    || service.url === '/complete-registration'
    || service.url === '/documents-verification'
    || service.url === '/forgot-password'
    || service.url === '/success-request-reset-password'
    || service.url === '/update-password'
    || service.url === '/success-update-password'
  ) {
    // console.log('3')
    service.commonFacade.setIsShowNavigation(false);
    return true;
  }

  if (
    service.url === '/wager'
    || service.url === '/wager1'
    || service.url === '/wager2'
    || service.url === '/wager3'
    || service.url === '/wager4'
    || service.url === '/wager5'
    || service.url === '/wager6'
  ) {
    // console.log('4')
    service.commonFacade.setIsShowNavigation(true);
    service.commonFacade.setIsShowFooter(true);
    return true;
  }

  // console.log('5')
  return false;
}

const redirectToHomeScreen = (service: IService, homeScreen = '/wager'): void => {
  // if enable test component view for routes then skip process
  if (env.Environment.enableComponentView) return;

  service.router.navigateByUrl(homeScreen);
}
